// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"3390348c","513":"c1ab8f54","703":"8e2414f5","787":"3b5f9b79"}[chunkId] + ".chunk.js";
};